export enum JobStatusType {
  OPEN,
  SCHEDULED,
  IN_PROGRESS,
  PART_COMPLETED,
  COMPLETED,
  CANCELLED
}

export enum JobStatusLabelType {
  OPEN = 'Open',
  SCHEDULED = 'Scheduled',
  IN_PROGRESS = 'In Progress',
  PART_COMPLETED = 'Part Completed',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled'
}

export default JobStatusType
